import { IconButton, InputBase } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { useTranslation } from "react-i18next";

interface SearchBarProps {
  onSearch: (text: string) => any;
  placeholder?: string;
  defaultValue?: string;
  alwaysHighlighted?: boolean;
}

export default function SearchBar(props: SearchBarProps) {
  const { t } = useTranslation("DataView");
  const searchRef = useRef<HTMLDivElement | null>(null);
  const searchInput = useRef<HTMLInputElement | null>(null);
  const [searchExpanded, setSearchExpenaded] = useState(
    props.alwaysHighlighted ? true : Boolean(searchInput.current?.value || "")
  );
  useEffect(() => {
    if (props.defaultValue && searchInput.current)
      searchInput.current.value = props.defaultValue;
  }, [props.defaultValue, searchInput.current]);
  return (
    <InputBase
      ref={searchRef}
      inputRef={searchInput}
      sx={{
        borderRadius: (theme) => (theme.shape.borderRadius as number) / 8,
        bgcolor: (theme) =>
          searchExpanded ? theme.palette.background.paper : "none",
        px: 1,
        py: 1,
        width: 1,
        transitionDuration: "50ms",
        transitionTimingFunction: "ease-in-out",
      }}
      onFocus={(e) => {
        if (!props.alwaysHighlighted && searchRef.current)
          setSearchExpenaded(true);
      }}
      onBlur={(e) => {
        if (
          !props.alwaysHighlighted &&
          searchRef.current &&
          !searchInput.current?.value
        )
          setSearchExpenaded(false);
      }}
      onChange={() => {
        props.onSearch(searchInput.current?.value || "");
      }}
      // onKeyDown={(e) => {
      //   if (e.key === "Enter") {
      //     e.preventDefault();
      //     if (!breakpoint.md) e.currentTarget.blur();
      //     handleSearch(searchInput.current?.value || "");
      //   }
      // }}
      placeholder={t("Search", { topic: props.placeholder })}
      endAdornment={
        <IconButton size="small">
          <SearchIcon
            onClick={() => props.onSearch(searchInput.current?.value || "")}
          />
        </IconButton>
      }
    />
  );
}
